export default __webpack_public_path__ + "static/media/532.aee93217.svg";